import { Component, Input, OnInit } from "@angular/core";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { GAServices } from "src/app/core/services/ga.service";

@Component({
  selector: "ver-archivo",
  templateUrl: "./ver-archivo.component.html",
})
export class VerArchivoComponent implements OnInit {
  @Input() base64!: string;
  @Input() ga_id!: string;
  @Input() nombreArchivo!: string;

  constructor(
    private sanitizer: DomSanitizer,
    private gaServices: GAServices
  ) {}

  ngOnInit(): void {
    if (this.ga_id) {
      this.gaServices.downloadPost({ id: this.ga_id }).subscribe((resp) => {
        //console.log(resp)
        this.base64 = resp.base64;
        this.nombreArchivo = resp.originial_name;
      });
    }
  }

  displayModal = false;
  fileUrl!: SafeResourceUrl;

  mostrarArchivo() {
    let extension =
      this.nombreArchivo.includes(".") &&
      this.nombreArchivo.split(".").length > 0
        ? this.nombreArchivo.split(".").pop()
        : "";
    if (!extension) return;
    extension = extension.toLowerCase();

    const mimeType = this.getMimeType(extension);

    if (mimeType === "application/pdf" || mimeType.startsWith("image/")) {
      // Sanitize the URL before using it
      // const base64Data = 'data:' + mimeType + ';base64,' + this.base64;
      // this.fileUrl = this.sanitizer.bypassSecurityTrustResourceUrl(base64Data);
      // this.mostrarModal();
      const mimeType = this.getMimeType(extension);
      const byteCharacters = atob(this.base64);
      const byteNumbers = Array.from(byteCharacters, (char) =>
        char.charCodeAt(0)
      );
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: mimeType });
      const blobUrl = URL.createObjectURL(blob);
      window.open(blobUrl, "_blank");
    } else {
      // Handle file download
      const link = document.createElement("a");
      link.href = "data:" + mimeType + ";base64," + this.base64;
      link.download = this.nombreArchivo;
      link.click();
    }
  }

  getMimeType(extension: string): string {
    switch (extension) {
      case "pdf":
        return "application/pdf";
      case "jpg":
      case "jpeg":
        return "image/jpeg";
      case "png":
        return "image/png";
      case "gif":
        return "image/gif";
      default:
        return "application/octet-stream"; // Tipo por defecto para otros archivos
    }
  }

  mostrarModal() {
    this.displayModal = true; // Si usas PrimeNG, esto abre el Dialog
  }
}
